import { useRef, useState, KeyboardEvent } from 'react';

interface MessageInputProps {
  onSend: (content: string) => Promise<void>;
  disabled?: boolean;
}

export function MessageInput({ onSend, disabled }: MessageInputProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!value.trim() || disabled) return;
    onSend(value.trim());
    setValue('');
    textareaRef.current?.focus();
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 150)}px`;
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ flexShrink: 0, padding: '1rem', borderTop: '1px solid var(--border)', background: 'var(--bg-elevated)' }}>
      <div style={{ position: 'relative', display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
        <textarea
          ref={textareaRef}
          value={value}
          onChange={e => { setValue(e.target.value); adjustHeight(); }}
          onKeyDown={handleKeyDown}
          placeholder="Digite sua mensagem... (Enter para enviar, Shift+Enter para nova linha)"
          disabled={disabled}
          rows={1}
          style={{
            flex: 1,
            minHeight: '44px',
            maxHeight: '150px',
            resize: 'none',
            padding: '0.75rem 1rem',
            paddingRight: '3rem',
            fontSize: '1rem',
            lineHeight: 1.5,
          }}
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={!value.trim() || disabled}
          style={{
            position: 'absolute',
            right: '0.5rem',
            bottom: '0.5rem',
            padding: '0.5rem',
            borderRadius: 'var(--radius-sm)',
          }}
        >
          ➤
        </button>
      </div>
      <p style={{ fontSize: '0.7rem', color: 'var(--fg-muted)', marginTop: '0.375rem', textAlign: 'center' }}>
        O agente pode sugerir salvar memórias, criar follow-ups ou lembretes durante a conversa.
      </p>
    </form>
  );
}
